import { createContext } from 'react';

export type ChatMessageMenuState = {
  x: number;
  y: number;
  chatId: string;
  messageId: string;
};

export type TPosition = {
  x: number;
  y: number;
};

export type ChatMessageMenuProps = {
  chatMessageMenuState: ChatMessageMenuState | null;
  showChatMessageMenu: (chatId: string, messageId: string, position?: TPosition) => void;
  hideChatMessageMenu: () => void;
};

export const ChatMessageMenuContext = createContext<ChatMessageMenuProps | undefined>(undefined);
